import dayjs from 'dayjs';

export const getDays = (intl) => {
  return getLocaleAwareDaysArray().map(day => ({
    day,
    title: intl.formatMessage({
      id: `component.locationDrawer.${day}`,
      defaultMessage: day.charAt(0).toUpperCase() + day.slice(1),
    }),
    enabled: false,
    slots: [{ start: null, end: null }],
  }));
};

// Shared constant for day names (Monday first)
export const DAYS_OF_WEEK = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

// Base array starting with Sunday (for locale-aware mapping)
const DAYS_SUNDAY_FIRST = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

// Get locale-aware days array based on the current dayjs locale
export const getLocaleAwareDaysArray = () => {
  const firstDayOfWeek = dayjs.localeData().firstDayOfWeek();
  const result = [];
  for (let i = 0; i < 7; i++) {
    const dayIndex = (i + firstDayOfWeek) % 7;
    result.push(DAYS_SUNDAY_FIRST[dayIndex]);
  }
  return result;
};

// Generic transformation function for user working hours format (time-time)
export const transformUserWorkingHoursToSlots = (availability, intl) => {
  const daysLookup = getDays(intl);
  const daysOfWeek = daysLookup.map(d => d.day.toLowerCase());
  return daysOfWeek.map((day) => {
    const matchedDays = availability[day] || [];
    return {
      day: day.charAt(0).toUpperCase() + day.slice(1),
      title: daysLookup?.find(x => x.day === day)?.title,
      enabled: matchedDays.length > 0,
      slots: matchedDays.map((timeRange) => {
        const [start, end] = timeRange.split('-');
        return {
          start: start || null,
          end: end || null,
        };
      }),
    };
  });
};

// Generic transformation function for service type opening hours format (day/start/end objects)
export const transformServiceTypeOpenHoursToSlots = (openingHours, intl) => {
  const daysLookup = getDays(intl);

  return daysLookup.map(day => {
    const matchedHours = openingHours?.filter(oh => oh.day === day.day) || [];
    if (matchedHours.length > 0) {
      return {
        ...day,
        enabled: true,
        slots: matchedHours.map(oh => ({
          start: oh.start,
          end: oh.end
        }))
      };
    }
    return day;
  });
};

// Transform slots back to user working hours format
export const transformSlotsToUserWorkingHours = (data) => {
  return data.reduce((acc, day) => {
    if (day.enabled) {
      acc[day.day.toLowerCase()] = day.slots
        .filter(slot => slot.start && slot.end)
        .map(slot => `${slot.start}-${slot.end}`);
    } else {
      acc[day.day.toLowerCase()] = [];
    }
    return acc;
  }, {});
};

// Transform slots back to service type opening hours format
export const transformSlotsToServiceTypeOpenHours = (data) => {
  return data
    .filter(day => day.enabled && day.slots.length > 0)
    .flatMap(day => {
      return day.slots
        .filter(slot => slot.start && slot.end)
        .map(slot => ({
          day: day.day.toLowerCase(),
          start: dayjs(slot.start, "HH:mm").format("HH:mm"),
          end: dayjs(slot.end, "HH:mm").format("HH:mm"),
        }));
    });
};
